import { useHistory } from 'react-router';

export const useIframeMode = () => {
  const history = useHistory();
  return history.location.search.includes('iframe-mode=true');
};
